<template>
  <button v-if="coaching.billingType === 'individuell'"
          @click="downloadFile('/billing/private-coaching/individual-bill-preview',
                       undefined,
                       {...filters, id: coaching?.id})"
          class="btn btn-primary">Vorschau
  </button>

  <button v-if="coaching.billingType === 'endabrechnung'"
          @click="downloadFile('/billing/private-coaching/final-settlement-bill-preview',
                       undefined,
                       {...filters, id: coaching?.id})"
          class="btn btn-primary">Vorschau
  </button>

  <div v-if="coaching.billingType === 'pauschalabrechnung'">
    <button v-if="coaching.firstBill === true"
            @click="downloadFile(
                      `/billing/private-coaching/pauschal-first-bill-preview/${coaching.id}`,
                      undefined
                    )"
            class="btn btn-primary">Vorschau
    </button>
    <button v-if="coaching.finalBill === true"
            @click="downloadFile(
                      `/billing/private-coaching/pauschal-final-bill-preview/${coaching.id}`,
                      undefined
                    )"
            class="btn btn-primary">Vorschau
    </button>
  </div>
</template>

<script setup>
import {downloadFile} from "@/shared/functions";
import {defineProps, toRefs} from "vue";

const props = defineProps({
  coaching: {
    type: Object,
    required: true,
  },
  filters: {
    type: Object,
    required: true,
  },
});

const {filters, coaching} = toRefs(props);
</script>
<style scoped>

</style>